import { CampaignResponse, AdvertisementResponse, ViewershipResult } from 'jsonutils/reports';
import {
	GET_CAMPAIGN_REPORT_LIST,
	ClientReportsAction,
	UPDATE_CAMPAIGN_REPORTS,
	GET_ADVERTISEMENT_REPORT_LIST,
	UPDATE_ADVERTISEMENT_REPORTS,
	GET_VIEWERSHIP_REPORT_LIST,
	RESET_CLIENT_REPORTS,
} from 'store/types/clientReports';
export interface ClientReportStore {
	list: Array<any>;
	campaignResponse: CampaignResponse;
	advertisementResponse: AdvertisementResponse;
	advertisementResponselist: Array<any>;
	viewershipResponse:ViewershipResult;
	campaignTotalValue:any;
}
const emptyViewershipResult: ViewershipResult = {
	dateArray: [],
	actualViewershipArray: [],
	potentialViewershipArray: [],
};

const emptyCampaignResponse: CampaignResponse = {
	campaignId: 0,
	campaignName: '',
	startDate: new Date(),
	endDate: new Date(),
};

const emptyAdvertisementResponse: AdvertisementResponse = {
	adId: 0,
	startDate: new Date(),
	endDate: new Date(),
	name: '',
};

const initialState: ClientReportStore = {
	list: [],
	campaignResponse: emptyCampaignResponse,
	advertisementResponse: emptyAdvertisementResponse,
	advertisementResponselist: [],
	viewershipResponse:emptyViewershipResult,
	campaignTotalValue:{}
};

export const clientReportsReducer = (
	state = initialState,
	action: ClientReportsAction,
): ClientReportStore => {
	switch (action.type) {
		case GET_CAMPAIGN_REPORT_LIST: {
			return {
				...state,
				list: action.payload.data,
				campaignTotalValue:action.payload.totalData
			};
		}
		case UPDATE_CAMPAIGN_REPORTS: {
			return {
				...state,
				campaignResponse: { ...state.campaignResponse, ...action.payload },
			};
		}
		case GET_ADVERTISEMENT_REPORT_LIST: {
			return {
				...state,
				advertisementResponselist: action.payload,
			};
		}
		case UPDATE_ADVERTISEMENT_REPORTS: {
			return {
				...state,
				advertisementResponse: {
					...state.advertisementResponse,
					...action.payload,
				},
			};
		}
		case GET_VIEWERSHIP_REPORT_LIST:{
			return{
				...state,
				viewershipResponse:action.payload,
			};
		}
		case RESET_CLIENT_REPORTS:{
			return{
				...state,
				list:[],
				campaignResponse:emptyCampaignResponse,
				advertisementResponse:emptyAdvertisementResponse,
				advertisementResponselist:[],
				viewershipResponse:emptyViewershipResult,
			}
		}
		default: {
			return {
				...state,
			};
		}
	}
};
